<template>
    <b-table v-if="bills.length > 0" :thead-class="head_class" :tbody-tr-class="rowClass"
             striped class="table-responsive-xl resolution_table" :items="bills" :fields="fields">

        <template v-slot:head(date)="data">
            {{__t('PAY_MONTH')}}
        </template>

        <template v-slot:head(status)="data">
            {{__t('BILL_STATUS')}}
        </template>

        <template v-slot:head(bill_id)="data">
            {{__t('ACTION')}}
        </template>


        <template v-slot:head(cost)="data">
            {{__t('COST')}}
        </template>

        <template v-slot:cell(bill_id)="data">
            <div v-if="data.item.status == 'invoice'">
                <button type="button" class="btn  btn-success waves-effect waves-themed" v-on:click="make_payment(data.item)">
                    <span class="fal fa-download mr-1"></span>
                     {{__t('PAY')}}
                </button>
            </div>
        </template>

        <template v-slot:cell(cost)="data">
            <div class="d-inline-flex align-items-start">
                <div>
                    {{ data.item.cost | toCurrency }}

                    <div
                        v-if="extraAddValue(data.item) !== 0"
                        class="extra-add"
                        :class="extraAddClass(data.item)"
                    >
                        {{ extraAddSign(data.item) }}{{ Math.abs(extraAddValue(data.item)) | toCurrency }}
                    </div>
                </div>

                <div>
            <span class="badge badge-success ml-2" v-if="data.item.status == 'regular' || data.item.status == 'pay'">
                {{__t('PAY')}}
            </span>
                </div>
            </div>
        </template>
    </b-table>
</template>

<script>
export default {
    name: "bills",
    props : {
        "bills" : {
            type : Array
        }
    },
    data() {
        return {
            fields: [
                {
                    key: 'date',
                    label: '',
                    class: 'text-left'
                },

                {
                    key: "status",
                    label: '',
                    class: 'text-left'
                },


                {
                    key: "bill_id",
                    label: 'Action',
                    class: 'text-left'
                },

                {
                    key: 'cost',
                    label: '',
                    class: 'text-center'
                },
            ],
        }
    },

    methods : {
        rowClass(item) {
            if (!item) return;
            return item.class;
        },
        make_payment (bill) {
            EventBus.$emit("show_pay",parseInt(bill.bill_id));
        },
        extraAddValue(item) {
            return parseInt(item?.extra_add?.uah_cost || 0, 10) || 0;
        },
        extraAddSign(item) {
            const v = this.extraAddValue(item);
            return v > 0 ? '+' : '−';
        },
        extraAddClass(item) {
            const v = this.extraAddValue(item);
            return v > 0 ? 'text-danger' : 'text-success';
        },
    },
    computed : {

        head_class() {

        },
    }
}
</script>

<style scoped>
.extra-add {
    font-size: 0.85em;
    line-height: 1.1;
    margin-top: 2px;
    font-weight: 600;
}
</style>
